import { PaneArea } from '../../types/shared'
import ScaledLine, { IScaledLineAttrs } from '../canvas/scaled_line'
import PaneModel from '../models/pane'

type Area = PaneArea
type Attrs = IScaledLineAttrs
type PartialAttrs = Partial<Attrs>

class LineCreator extends ScaledLine<Attrs> {
  mouseDowns = 1
  isCreator = true

  constructor(startArea: Area, values: PartialAttrs, model: PaneModel, _: unknown, toolsCallback: () => void) {
    super(values, model)

    this.attrs.x1 = this.attrs.x2 = startArea.x
    this.attrs.y1 = this.attrs.y2 = startArea.y
    this.toolsCallback = toolsCallback

    window.gtag?.('event', 'create', { event_category: 'tools', event_label: this.name })
  }

  onMouseDown() {
    this.mouseDowns++
    if (this.mouseDowns > 1) {
      this.release()
      this.replaceMyself(ScaledLine.fromObject<ScaledLine>(this.attrs, this.model))
      this.toolsCallback()
    }
  }

  onMouseMove(area: Area) {
    this.attrs.x2 = area.x // - @startArea.x
    this.attrs.y2 = area.y // - @startArea.y
    this.trigger('change')
  }
}

export default LineCreator
